import axios from "axios";

export const state = {
    feespayments: [],
};

export const getters = {
    feespayments: state => state.feespayments,
};

export const mutations = {
    setFeesPayments(state, newValue) {
        state.feespayments = newValue
    },
};

export const actions = {
    fetchFeesPayments({ commit }) {
        axios.get('/feespayments').then(res => {
            commit('setFeesPayments', res.data.payments);
        })
    },
    filterFeesPayments({commit}, {schoolterm,year,schoolclass}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        formData.append("schoolclass", schoolclass);
        let url = "/filterfeespayments";
        axios.post(url, formData).then((response) => {
            commit('setFeesPayments', response.data.payments)
        })
    },
};
